import {
  ProductListConfigurationKeys,
  PRODUCT_LIST_NAMESPACE,
} from '@epicuro-next/constants/rule-engine/product-list-rules';
import {
  CONFIGURATIONS_PROVIDER_KEY,
  LIST_ACCESS_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';
import {
  LogicOperator,
  Operation,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export const isListDetailTab: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListDetailTab',
    },
    true,
  ],
];

export const isNormalList: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListNormal',
    },
    true,
  ],
];

export const isNotCommercialList: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListCommercial',
    },
    false,
  ],
];

export const isCommercialList: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListCommercial',
    },
    true,
  ],
];

export const isPowerList: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isPowerList',
    },
    true,
  ],
];

export const isNotPowerList: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isPowerList',
    },
    false,
  ],
];

export const isOwnerOfOpenedList = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isOwnerOfOpenedList',
    },
    true,
  ],
];

export const isNotOwnerOfOpenedList = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isOwnerOfOpenedList',
    },
    false,
  ],
];

export const isListAllowedForEdit = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListAllowedForEdit',
    },
    true,
  ],
];

export const isListNotAllowedForEdit = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListAllowedForEdit',
    },
    false,
  ],
];

export const isListNotDeleted: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListDeleted',
    },
    false,
  ],
];

export const isEmptyAvailableProducts = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'availableProductsCount',
    },
    0,
  ],
];

export const hasSpotlightNewsFeedId = [
  LogicOperator.NOT,
  [
    LogicOperator.EQ,
    [
      {
        provider: OPENED_LIST_DATA_PROVIDER_KEY,
        property: 'newsfeedId',
      },
      null,
    ],
  ],
];

export const isNotSpotlightPromoted = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'newsfeedId',
    },
    null,
  ],
];

export const hasModalNewsFeedId = [
  LogicOperator.NOT,
  [
    LogicOperator.EQ,
    [
      {
        provider: OPENED_LIST_DATA_PROVIDER_KEY,
        property: 'welcomePromotionNewsfeedId',
      },
      null,
    ],
  ],
];

export const isNotModalPromoted = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'welcomePromotionNewsfeedId',
    },
    null,
  ],
];

export const hasLandingPageNewsFeedId = [
  LogicOperator.NOT,
  [
    LogicOperator.EQ,
    [
      {
        provider: OPENED_LIST_DATA_PROVIDER_KEY,
        property: 'landingPageNewsfeedId',
      },
      null,
    ],
  ],
];

export const isNotLandingPagePromoted = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'landingPageNewsfeedId',
    },
    null,
  ],
];

export const epicShowIf = [
  LogicOperator.AND,
  [
    [
      LogicOperator.EQ,
      [
        {
          provider: CONFIGURATIONS_PROVIDER_KEY,
          property: {
            namespace: PRODUCT_LIST_NAMESPACE,
            featureName: ProductListConfigurationKeys.ShowEpicShow,
            defaultValue: false,
          },
        },
        true,
      ],
    ],
    isOwnerOfOpenedList,
    isNormalList,
    isListNotDeleted,
  ],
];
